<div class="thank-you-redirect">
  <div class="loader-content"><ng-lottie width="500" [options]="lottieConfig"></ng-lottie></div>
  <div class="text-content">
    <h1 class="title_42">{{ "THANK_YOU_REDIRECT.TITLE" | translate }}</h1>
    <p class="subdesc">{{ "THANK_YOU_REDIRECT.TEXT" | translate }}</p>
  </div>
</div>
